import React, { useEffect, useState } from 'react'
import Footer from '../components/Footer';
import Header from '../components/Header';
import DemoRequestModal from '../components/DemoModal';

function PrivacyPolicy() {
  const [show, setShow] = useState(false)
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleOpen = (v) => {
    setShow(true)
  }
  return (
    <React.Fragment>
       <Header handleOpen={handleOpen} />
      <div
        style={{
          position: "fixed",
          top: position.y,
          left: position.x,
          width: "25px",
          height: "25px",
          backgroundColor: "rgb(87, 169, 255)",
          borderRadius: "50%",
          zIndex: 22,
          pointerEvents: "none",
          transform: "translate(-50%, -50%)",
          transition: "transform 0.1s ease-out",
        }}
      />
     
      <main className="second-landing-page">
        <div className="container py-5">
          <div className="card pp-page ">
            <section className="mb-4">
              <h3>General</h3>
              <p>
                This Privacy Policy governs the online data collection practices of <strong>CV Infotech Private Limited</strong> ("CVHRMS," "we," or "us"). It explains how we collect, use, and protect your data when you visit our website <a href="https://cvhrms.com" target="_blank" rel="noopener noreferrer">https://cvhrms.com</a>.
              </p>
              <p>
                CVHRMS is a SaaS-based HRMS platform enabling registered users ("Users") to manage HR processes, share content, and analyze interactions by their customers or employees ("Viewers"). Viewers are non-registered users interacting with our Services.
              </p>
            </section>

            <section className="mb-4">
              <h3>Purpose and Scope</h3>
              <ul>
                <li>
                  The types of information we collect
                  </li>
                <li>How we use that information</li>
                <li>Your rights regarding your personal data</li>
              </ul>
              <p>
                Further details may be covered in individual customer contracts. Opt-in/out notices may also be presented during data collection.
              </p>
            </section>

            <section className="mb-4">
              <h3>Information We Collect</h3>
              <ul>
                <li>Personally identifiable info (name, email, phone, job title, IP, etc.)</li>
                <li>Technical and usage data (browser, device, usage patterns)</li>
                <li>Communication records (chat, emails)</li>
              </ul>
              <p>
                Information is gathered directly from you, automatically using cookies, or via third parties (e.g., social media).
              </p>
            </section>

            <section className="mb-4">
              <h3>How We Use Your Information</h3>
              <ul>
                <li>Deliver and manage our services</li>
                <li>Respond to inquiries</li>
                <li>Personalize experiences</li>
                <li>Improve our platform</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-4">
              <h3>Disclosure of Your Information</h3>
              <ul>
                <li>With affiliates and partners</li>
                <li>For legal compliance</li>
                <li>In the event of mergers/acquisitions</li>
                <li>To protect rights, safety, or enforce terms</li>
                <li>With your consent</li>
              </ul>
            </section>

            <section className="mb-4">
              <h3>Your Rights</h3>
              <ul>
                <li>Access or delete your data</li>
                <li>Correct inaccurate information</li>
                <li>Request data portability or processing restriction</li>
                <li>Withdraw consent or object to processing</li>
              </ul>
              <p>
                To exercise your rights, email us at <a href="mailto:hrms@cvinfotech.com">hrms@cvinfotech.com</a>
              </p>
            </section>

            <section className="mb-4">
              <h3>Cookies and Tracking</h3>
              <ul>
                <li>Session management and authentication</li>
                <li>Site performance analysis</li>
                <li>Advertising and user personalization</li>
              </ul>
              <p>You can manage cookies through browser settings.</p>
            </section>

            <section className="mb-4">
              <h3>Data Security</h3>
              <p>
                We employ SSL encryption, firewalls, and secure servers to protect your data. While we take precautions, no system is 100% secure.
              </p>
            </section>

            <section className="mb-4">
              <h3>Children Under 16</h3>
              <p>
                Our platform is not intended for users under the age of 16. If such data is collected without consent, it will be deleted immediately.
              </p>
            </section>

            <section className="mb-4">
              <h3>Data Retention</h3>
              <p>
                We retain personal data as long as necessary for business, legal, or compliance purposes, based on internal policies and applicable laws.
              </p>
            </section>

            <section className="mb-4">
              <h3>Policy Changes</h3>
              <p>
                Updates to this policy will be posted on our website. Continued use after changes implies acceptance.
              </p>
            </section>

            <section>
              <h3>Contact Information</h3>
              <p>
                For privacy-related questions or to exercise your rights, contact us at:
                <br />
                <strong>Email:</strong> <a href="mailto:hrms@cvinfotech.com">hrms@cvinfotech.com</a>
              </p>
            </section>
          </div>
        </div>
        <DemoRequestModal show={show} handleClose={() => { setShow(false) }} />
        <Footer />
      </main>
      <div className="back-to-top">
        <a className={`back-to-top-icon align-items-center justify-content-center d-flex ${showBackToTop ? "show" : ""}`} href="#top"><i className="fa-solid fa-arrow-up"></i></a>
      </div>

    </React.Fragment>
  );
}


export default PrivacyPolicy
